import apiCall from "./ApiCallInstance";

/**
 * FetchInterceptor (legacy compatibility layer)
 * ---------------------------------------------
 * Historically the app had two separate axios instances which caused
 * inconsistent auth handling and random logouts. Everything now flows through
 * the single, robust `ApiCallInstance` (see ./ApiCallInstance.js) which owns
 * the refresh-token logic.
 *
 * This module is kept ONLY for backward compatibility: a lot of older code
 * imports `fetch`/`service` from here and expects the *unwrapped* response
 * payload (i.e. `response.data`) rather than the full axios response.
 *
 * It is a thin wrapper around `ApiCallInstance` that unwraps `.data`, so both
 * calling conventions continue to work against the same underlying instance
 * and the same (single) refresh mechanism.
 */

const unwrap = (promise) => promise.then((res) => res.data);

const service = (config) => unwrap(apiCall(config));

service.request = (config) => unwrap(apiCall(config));
service.get = (url, config) => unwrap(apiCall.get(url, config));
service.delete = (url, config) => unwrap(apiCall.delete(url, config));
service.head = (url, config) => unwrap(apiCall.head(url, config));
service.options = (url, config) => unwrap(apiCall.options(url, config));
service.post = (url, data, config) => unwrap(apiCall.post(url, data, config));
service.put = (url, data, config) => unwrap(apiCall.put(url, data, config));
service.patch = (url, data, config) => unwrap(apiCall.patch(url, data, config));

// Expose the raw instance for anything that needs the full response object.
service.instance = apiCall;

export default service;
